/* NURIALE MODERN — scroll reveals (June 2026).
   Companion to nuriale-modern.css. Adds staggered fade-up reveals to
   sections the theme's native reveal-on-scroll system doesn't cover.
   Bails out entirely for reduced-motion users and old browsers, and never
   hides elements that are already in the viewport (no flash). */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('nur-js');

  function init() {
    var staggered = [
      '.shopify-section--subcategory-pills .subcat-pill',
      '.shopify-section--text-with-icons .text-with-icons__item',
      '.shopify-section--newsletter .content.section-stack > *'
    ];
    var singles = [
      '.shopify-section--subcategory-pills .section-header',
      '.shopify-section--featured-collections .section-header',
      '.shopify-section--apps [data-oke-carousel]'
    ];

    var targets = [];

    staggered.forEach(function (sel) {
      var counts = {};
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.closest('[reveal-on-scroll]')) return;
        var sec = el.closest('.shopify-section');
        var key = (sec && sec.id) || 'page';
        counts[key] = counts[key] || 0;
        el.style.setProperty('--nur-i', Math.min(counts[key]++, 5));
        targets.push(el);
      });
    });

    singles.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.closest('[reveal-on-scroll]')) return;
        targets.push(el);
      });
    });

    if (!targets.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('nur-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (el) {
      var r = el.getBoundingClientRect();
      // Already on screen at load: leave it visible rather than animating.
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) return;
      el.setAttribute('data-nur-reveal', '');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
